import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import * as _ from 'lodash';
import { apiURL, EnvConfig } from "../../../../env-config";
import { HttpService } from "../../../../http.service";
import { UtilsService } from "../../../shared/services/utils.service";
import { AuthService } from "../../../shared/services/auth.service";
import { IFilter } from "../../../shared/interfaces/filter.interface";

@Injectable()
export class DashboardHttpService {
  constructor(
    private _http: HttpService,
    private _utilsService: UtilsService,
    private _AuthService: AuthService
  ) { }

  getDashboards(filter?: IFilter): Observable<any[]> {
    let queryParams: string = !_.isEmpty(filter) ? '?' + this._utilsService.toQueryString(filter) : '';
    return this._http.get(`${apiURL(EnvConfig.API_PROJECTS)}${queryParams}`)
  }

  getDashboard(project: any | string): Observable<any> {
    let id = (typeof project == 'string') ? project : project._id;
    return this._http.get(`${apiURL(EnvConfig.API_PROJECTS)}/${id}`);
  }

}